import axios from 'axios'

const GET_ADDRESS_URL = 'https://maps.googleapis.com/maps/api/geocode/json'

const STREET_TYPES = ['route']
const COUNTRY_TYPES = ['country']
const ADDRESS_TYPES = ['locality', 'administrative_area_level_1']

const errorMapper = error => {
  const payload = error?.response?.data?.message ?? error?.message
  return payload
}

const normalizeString = str =>
  str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .normalize('NFC')

const responseMapper = data => {
  const addressComponents = data?.results[0]?.address_components ?? []
  const street =
    addressComponents.find(element => STREET_TYPES.includes(element.types[0]))
      ?.long_name ?? ''
  const city =
    addressComponents.find(element => ADDRESS_TYPES.includes(element.types[0]))
      ?.long_name ?? ''
  const country =
    addressComponents.find(element => COUNTRY_TYPES.includes(element.types[0]))
      ?.long_name ?? ''
  return {
    street: normalizeString(street),
    country: normalizeString(country),
    city: normalizeString(city) === 'Tirane' ? 'Tirana' : normalizeString(city)
  }
}

export const getAddress = async ({
  coordinate: { latitude, longitude },
  apiKey
}) => {
  try {
    const response = await axios.get(GET_ADDRESS_URL, {
      params: {
        key: apiKey,
        latlng: `${latitude},${longitude}`
      }
    })
    const _response = responseMapper(response.data)
    return { success: true, data: _response }
  } catch (err) {
    return { success: false, data: errorMapper(err) }
  }
}
